import React, { useState, useEffect } from 'react';

import { Container, CardBody, Card } from 'reactstrap';
import IntlMessage from '../../../../../../../helpers/intlMessage';
import { DataTable, Column } from 'vivace-fluent-motion';
import { arquivamentoTipoEmum } from '../../../../../arquivamento.utils';

function Table ({ lista, setListaItensSelecionados }) {
  const [listaFormatada, setListaFormatada] = useState([]);

  useEffect(() => {
    const listFormated = lista.map(x => ({
      ...x,
      tipoFormated: x.tipo === arquivamentoTipoEmum.BLOCO ? 'Bloco' : 'Lâmina',
      select: (
        <input
          className='checkbox'
          name='checkbox'
          type='checkbox'
          id={`checkbox_${x.idMaterial}_${x.tipo}_${x.laudo}`}
          onClick={e => selectItem(e)}
        />
      )
    }));
    
    setListaFormatada(listFormated);
    resetSelecionadosTabela();
  }, [lista]);

  function setItens () {
    let listaIds = [];
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    checkboxes.forEach(c =>
      listaIds.push({
        idMaterial: Number(c.id.split('_')[1]),
        tipo: Number(c.id.split('_')[2]),
        laudo: Number(c.id.split('_')[3])
      })
    );
    setListaItensSelecionados(listaIds);
  }

  function selectItem (e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');

    if (checkboxes.length === 0) {
      document.getElementById('select').checked = false;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
    setItens();
  }

  function toggle (checked) {
    let checkboxes = document.getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        if (checked) {
          document
            .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
        } else {
          document
            .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
        }
      }
    }
    setItens();
  }

  function resetSelecionadosTabela () {
    
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      document
        .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
    }
    let checkboxes = document.querySelectorAll('input[name=checkbox]:checked');
    checkboxes.forEach(
      element => (document.getElementById(element.id).checked = false)
    );
    setListaItensSelecionados([])
  }

  function onChangeSelect (e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id ===
          `checkbox_${e.data.idMaterial}_${e.data.tipo}_${e.data.laudo}`
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(
              `checkbox_${e.data.idMaterial}_${e.data.tipo}_${e.data.laudo}`
            ).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(
              `checkbox_${e.data.idMaterial}_${e.data.tipo}_${e.data.laudo}`
            ).checked = true;
          }
        }
      }
    }
    setItens();
  }

  return (
    <Card style={{ marginTop: '15px' }}>
      <CardBody>
        <Container fluid>
          <DataTable
            onContextMenu={e => onChangeSelect(e)}
            value={listaFormatada}
            responsive={true}
            selectionMode='single'
            style={{ height: '100%' }}
            columnResizeMode='expand'
            scrollable={true}
            scrollHeight='50vh'
            scrollWidth='100%'
            resizableColumns={listaFormatada.length >= 1}
            reorderableColumns={listaFormatada.length >= 1}
            lazy={true}
            emptyMessage={<IntlMessage id="general.materialArchiving.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
          >
            <Column
              field='select'
              style={{ width: '25px' }}
              header={
                listaFormatada.length >= 1 && (
                  <input
                    type='checkbox'
                    id='select'
                    name='select'
                    onChange={e => toggle(e.target.checked)}
                  />
                )
              }
            />
            <Column
              field='numeroMaterial'
              style={{ width: '230px' }}
              header={<IntlMessage id="general.materialArchiving.identification" />} 
            />
            <Column field='exame' style={{ width: '150px' }} header={<IntlMessage id="general.materialArchiving.exam" />} />
            <Column
              field='paciente'
              style={{ width: '250px' }}
              header={<IntlMessage id="general.materialArchiving.patient" />}
            />
            <Column
              field='medicoExecutante'
              style={{ width: '250px' }}
              header={<IntlMessage id="general.materialArchiving.requester" />}
            />
            <Column
              field='tipoFormated'
              style={{ width: '80px' }}
              header={<IntlMessage id="general.materialArchiving.type" />}
            />            
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/ArquivamentoManual/Table/index.js